// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.4
//   protoc               v5.28.2
// source: stcs_wapp_settings.entity.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "stcs_cmw";

export interface StcsWappSettings {
  id: string;
  version: string;
  meta:
    | StcsWappSettingsMeta
    | undefined;
  /** One organization settings per payment subscription */
  org:
    | StcsWappSettingsConfig
    | undefined;
  /** Multiple company settings per organization */
  comp: { [key: string]: StcsWappSettingsCompConfig };
}

export interface StcsWappSettings_CompEntry {
  key: string;
  value: StcsWappSettingsCompConfig | undefined;
}

export interface StcsWappSettingsMeta {
  ref_id_org: string;
  obj_updated_iso_utc: string;
  obj_created_iso_utc: string;
}

export interface StcsWappSettingsConfig {
  sub_section_map: { [key: string]: string };
}

export interface StcsWappSettingsConfig_SubSectionMapEntry {
  key: string;
  value: string;
}

export interface StcsWappSettingsCompConfig {
  /** comp config name as key */
  sub_section_map: { [key: string]: string };
  /** UserID as key */
  user: { [key: string]: StcsWappSettingsConfig };
}

export interface StcsWappSettingsCompConfig_SubSectionMapEntry {
  key: string;
  value: string;
}

export interface StcsWappSettingsCompConfig_UserEntry {
  key: string;
  value: StcsWappSettingsConfig | undefined;
}

function createBaseStcsWappSettings(): StcsWappSettings {
  return { id: "", version: "", meta: undefined, org: undefined, comp: {} };
}

export const StcsWappSettings: MessageFns<StcsWappSettings> = {
  encode(message: StcsWappSettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.version !== "") {
      writer.uint32(18).string(message.version);
    }
    if (message.meta !== undefined) {
      StcsWappSettingsMeta.encode(message.meta, writer.uint32(26).fork()).join();
    }
    if (message.org !== undefined) {
      StcsWappSettingsConfig.encode(message.org, writer.uint32(34).fork()).join();
    }
    Object.entries(message.comp).forEach(([key, value]) => {
      StcsWappSettings_CompEntry.encode({ key: key as any, value }, writer.uint32(42).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsWappSettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsWappSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.version = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.meta = StcsWappSettingsMeta.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.org = StcsWappSettingsConfig.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          const entry5 = StcsWappSettings_CompEntry.decode(reader, reader.uint32());
          if (entry5.value !== undefined) {
            message.comp[entry5.key] = entry5.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsWappSettings {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      version: isSet(object.version) ? globalThis.String(object.version) : "",
      meta: isSet(object.meta) ? StcsWappSettingsMeta.fromJSON(object.meta) : undefined,
      org: isSet(object.org) ? StcsWappSettingsConfig.fromJSON(object.org) : undefined,
      comp: isObject(object.comp)
        ? Object.entries(object.comp).reduce<{ [key: string]: StcsWappSettingsCompConfig }>((acc, [key, value]) => {
          acc[key] = StcsWappSettingsCompConfig.fromJSON(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: StcsWappSettings): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.version !== "") {
      obj.version = message.version;
    }
    if (message.meta !== undefined) {
      obj.meta = StcsWappSettingsMeta.toJSON(message.meta);
    }
    if (message.org !== undefined) {
      obj.org = StcsWappSettingsConfig.toJSON(message.org);
    }
    if (message.comp) {
      const entries = Object.entries(message.comp);
      if (entries.length > 0) {
        obj.comp = {};
        entries.forEach(([k, v]) => {
          obj.comp[k] = StcsWappSettingsCompConfig.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsWappSettings>, I>>(base?: I): StcsWappSettings {
    return StcsWappSettings.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsWappSettings>, I>>(object: I): StcsWappSettings {
    const message = createBaseStcsWappSettings();
    message.id = object.id ?? "";
    message.version = object.version ?? "";
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? StcsWappSettingsMeta.fromPartial(object.meta)
      : undefined;
    message.org = (object.org !== undefined && object.org !== null)
      ? StcsWappSettingsConfig.fromPartial(object.org)
      : undefined;
    message.comp = Object.entries(object.comp ?? {}).reduce<{ [key: string]: StcsWappSettingsCompConfig }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsWappSettingsCompConfig.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseStcsWappSettings_CompEntry(): StcsWappSettings_CompEntry {
  return { key: "", value: undefined };
}

export const StcsWappSettings_CompEntry: MessageFns<StcsWappSettings_CompEntry> = {
  encode(message: StcsWappSettings_CompEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsWappSettingsCompConfig.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsWappSettings_CompEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsWappSettings_CompEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsWappSettingsCompConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsWappSettings_CompEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsWappSettingsCompConfig.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsWappSettings_CompEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsWappSettingsCompConfig.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsWappSettings_CompEntry>, I>>(base?: I): StcsWappSettings_CompEntry {
    return StcsWappSettings_CompEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsWappSettings_CompEntry>, I>>(object: I): StcsWappSettings_CompEntry {
    const message = createBaseStcsWappSettings_CompEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsWappSettingsCompConfig.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseStcsWappSettingsMeta(): StcsWappSettingsMeta {
  return { ref_id_org: "", obj_updated_iso_utc: "", obj_created_iso_utc: "" };
}

export const StcsWappSettingsMeta: MessageFns<StcsWappSettingsMeta> = {
  encode(message: StcsWappSettingsMeta, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.ref_id_org !== "") {
      writer.uint32(10).string(message.ref_id_org);
    }
    if (message.obj_updated_iso_utc !== "") {
      writer.uint32(26).string(message.obj_updated_iso_utc);
    }
    if (message.obj_created_iso_utc !== "") {
      writer.uint32(34).string(message.obj_created_iso_utc);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsWappSettingsMeta {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsWappSettingsMeta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.ref_id_org = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.obj_updated_iso_utc = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.obj_created_iso_utc = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsWappSettingsMeta {
    return {
      ref_id_org: isSet(object.ref_id_org) ? globalThis.String(object.ref_id_org) : "",
      obj_updated_iso_utc: isSet(object.obj_updated_iso_utc) ? globalThis.String(object.obj_updated_iso_utc) : "",
      obj_created_iso_utc: isSet(object.obj_created_iso_utc) ? globalThis.String(object.obj_created_iso_utc) : "",
    };
  },

  toJSON(message: StcsWappSettingsMeta): unknown {
    const obj: any = {};
    if (message.ref_id_org !== "") {
      obj.ref_id_org = message.ref_id_org;
    }
    if (message.obj_updated_iso_utc !== "") {
      obj.obj_updated_iso_utc = message.obj_updated_iso_utc;
    }
    if (message.obj_created_iso_utc !== "") {
      obj.obj_created_iso_utc = message.obj_created_iso_utc;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsWappSettingsMeta>, I>>(base?: I): StcsWappSettingsMeta {
    return StcsWappSettingsMeta.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsWappSettingsMeta>, I>>(object: I): StcsWappSettingsMeta {
    const message = createBaseStcsWappSettingsMeta();
    message.ref_id_org = object.ref_id_org ?? "";
    message.obj_updated_iso_utc = object.obj_updated_iso_utc ?? "";
    message.obj_created_iso_utc = object.obj_created_iso_utc ?? "";
    return message;
  },
};

function createBaseStcsWappSettingsConfig(): StcsWappSettingsConfig {
  return { sub_section_map: {} };
}

export const StcsWappSettingsConfig: MessageFns<StcsWappSettingsConfig> = {
  encode(message: StcsWappSettingsConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    Object.entries(message.sub_section_map).forEach(([key, value]) => {
      StcsWappSettingsConfig_SubSectionMapEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsWappSettingsConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsWappSettingsConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = StcsWappSettingsConfig_SubSectionMapEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.sub_section_map[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsWappSettingsConfig {
    return {
      sub_section_map: isObject(object.sub_section_map)
        ? Object.entries(object.sub_section_map).reduce<{ [key: string]: string }>((acc, [key, value]) => {
          acc[key] = String(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: StcsWappSettingsConfig): unknown {
    const obj: any = {};
    if (message.sub_section_map) {
      const entries = Object.entries(message.sub_section_map);
      if (entries.length > 0) {
        obj.sub_section_map = {};
        entries.forEach(([k, v]) => {
          obj.sub_section_map[k] = v;
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsWappSettingsConfig>, I>>(base?: I): StcsWappSettingsConfig {
    return StcsWappSettingsConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsWappSettingsConfig>, I>>(object: I): StcsWappSettingsConfig {
    const message = createBaseStcsWappSettingsConfig();
    message.sub_section_map = Object.entries(object.sub_section_map ?? {}).reduce<{ [key: string]: string }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseStcsWappSettingsConfig_SubSectionMapEntry(): StcsWappSettingsConfig_SubSectionMapEntry {
  return { key: "", value: "" };
}

export const StcsWappSettingsConfig_SubSectionMapEntry: MessageFns<StcsWappSettingsConfig_SubSectionMapEntry> = {
  encode(message: StcsWappSettingsConfig_SubSectionMapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsWappSettingsConfig_SubSectionMapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsWappSettingsConfig_SubSectionMapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsWappSettingsConfig_SubSectionMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: StcsWappSettingsConfig_SubSectionMapEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsWappSettingsConfig_SubSectionMapEntry>, I>>(
    base?: I,
  ): StcsWappSettingsConfig_SubSectionMapEntry {
    return StcsWappSettingsConfig_SubSectionMapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsWappSettingsConfig_SubSectionMapEntry>, I>>(
    object: I,
  ): StcsWappSettingsConfig_SubSectionMapEntry {
    const message = createBaseStcsWappSettingsConfig_SubSectionMapEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseStcsWappSettingsCompConfig(): StcsWappSettingsCompConfig {
  return { sub_section_map: {}, user: {} };
}

export const StcsWappSettingsCompConfig: MessageFns<StcsWappSettingsCompConfig> = {
  encode(message: StcsWappSettingsCompConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    Object.entries(message.sub_section_map).forEach(([key, value]) => {
      StcsWappSettingsCompConfig_SubSectionMapEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    Object.entries(message.user).forEach(([key, value]) => {
      StcsWappSettingsCompConfig_UserEntry.encode({ key: key as any, value }, writer.uint32(18).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsWappSettingsCompConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsWappSettingsCompConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = StcsWappSettingsCompConfig_SubSectionMapEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.sub_section_map[entry1.key] = entry1.value;
          }
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          const entry2 = StcsWappSettingsCompConfig_UserEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.user[entry2.key] = entry2.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsWappSettingsCompConfig {
    return {
      sub_section_map: isObject(object.sub_section_map)
        ? Object.entries(object.sub_section_map).reduce<{ [key: string]: string }>((acc, [key, value]) => {
          acc[key] = String(value);
          return acc;
        }, {})
        : {},
      user: isObject(object.user)
        ? Object.entries(object.user).reduce<{ [key: string]: StcsWappSettingsConfig }>((acc, [key, value]) => {
          acc[key] = StcsWappSettingsConfig.fromJSON(value);
          return acc;
        }, {})
        : {},
    };
  },

  toJSON(message: StcsWappSettingsCompConfig): unknown {
    const obj: any = {};
    if (message.sub_section_map) {
      const entries = Object.entries(message.sub_section_map);
      if (entries.length > 0) {
        obj.sub_section_map = {};
        entries.forEach(([k, v]) => {
          obj.sub_section_map[k] = v;
        });
      }
    }
    if (message.user) {
      const entries = Object.entries(message.user);
      if (entries.length > 0) {
        obj.user = {};
        entries.forEach(([k, v]) => {
          obj.user[k] = StcsWappSettingsConfig.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsWappSettingsCompConfig>, I>>(base?: I): StcsWappSettingsCompConfig {
    return StcsWappSettingsCompConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsWappSettingsCompConfig>, I>>(object: I): StcsWappSettingsCompConfig {
    const message = createBaseStcsWappSettingsCompConfig();
    message.sub_section_map = Object.entries(object.sub_section_map ?? {}).reduce<{ [key: string]: string }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value);
        }
        return acc;
      },
      {},
    );
    message.user = Object.entries(object.user ?? {}).reduce<{ [key: string]: StcsWappSettingsConfig }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StcsWappSettingsConfig.fromPartial(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseStcsWappSettingsCompConfig_SubSectionMapEntry(): StcsWappSettingsCompConfig_SubSectionMapEntry {
  return { key: "", value: "" };
}

export const StcsWappSettingsCompConfig_SubSectionMapEntry: MessageFns<StcsWappSettingsCompConfig_SubSectionMapEntry> =
  {
    encode(
      message: StcsWappSettingsCompConfig_SubSectionMapEntry,
      writer: BinaryWriter = new BinaryWriter(),
    ): BinaryWriter {
      if (message.key !== "") {
        writer.uint32(10).string(message.key);
      }
      if (message.value !== "") {
        writer.uint32(18).string(message.value);
      }
      return writer;
    },

    decode(input: BinaryReader | Uint8Array, length?: number): StcsWappSettingsCompConfig_SubSectionMapEntry {
      const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
      let end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseStcsWappSettingsCompConfig_SubSectionMapEntry();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.key = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.value = reader.string();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    },

    fromJSON(object: any): StcsWappSettingsCompConfig_SubSectionMapEntry {
      return {
        key: isSet(object.key) ? globalThis.String(object.key) : "",
        value: isSet(object.value) ? globalThis.String(object.value) : "",
      };
    },

    toJSON(message: StcsWappSettingsCompConfig_SubSectionMapEntry): unknown {
      const obj: any = {};
      if (message.key !== "") {
        obj.key = message.key;
      }
      if (message.value !== "") {
        obj.value = message.value;
      }
      return obj;
    },

    create<I extends Exact<DeepPartial<StcsWappSettingsCompConfig_SubSectionMapEntry>, I>>(
      base?: I,
    ): StcsWappSettingsCompConfig_SubSectionMapEntry {
      return StcsWappSettingsCompConfig_SubSectionMapEntry.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<StcsWappSettingsCompConfig_SubSectionMapEntry>, I>>(
      object: I,
    ): StcsWappSettingsCompConfig_SubSectionMapEntry {
      const message = createBaseStcsWappSettingsCompConfig_SubSectionMapEntry();
      message.key = object.key ?? "";
      message.value = object.value ?? "";
      return message;
    },
  };

function createBaseStcsWappSettingsCompConfig_UserEntry(): StcsWappSettingsCompConfig_UserEntry {
  return { key: "", value: undefined };
}

export const StcsWappSettingsCompConfig_UserEntry: MessageFns<StcsWappSettingsCompConfig_UserEntry> = {
  encode(message: StcsWappSettingsCompConfig_UserEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      StcsWappSettingsConfig.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StcsWappSettingsCompConfig_UserEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStcsWappSettingsCompConfig_UserEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = StcsWappSettingsConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StcsWappSettingsCompConfig_UserEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? StcsWappSettingsConfig.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: StcsWappSettingsCompConfig_UserEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = StcsWappSettingsConfig.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StcsWappSettingsCompConfig_UserEntry>, I>>(
    base?: I,
  ): StcsWappSettingsCompConfig_UserEntry {
    return StcsWappSettingsCompConfig_UserEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StcsWappSettingsCompConfig_UserEntry>, I>>(
    object: I,
  ): StcsWappSettingsCompConfig_UserEntry {
    const message = createBaseStcsWappSettingsCompConfig_UserEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? StcsWappSettingsConfig.fromPartial(object.value)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
